import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import rest from '../../../lib/rest'
import FormSubcategoria from './formSubcategoria'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'

const CadastroSubCategoria = ()=> {

  const colunas = [
    {
      dataField: 'subcategoria_id',
      text: 'Código'
    },
    {
      dataField: 'subcategoria',
      text: 'Subcategoria'
     }//,
    // {
    //   dataField: 'desconto',
    //   text: 'Desconto'
    // },
    // {
    //   dataField: 'categoria',
    //   text: 'Categoria'
    // }
  ]

  const { SearchBar }                             = Search
  const [loading, setLoading]                     = useState(true)
  const [listaSubcategoria, setListaSubcategoria] = useState([])
  const [subcategoria_id, setSubcategoria_id]     = useState('')
  const [modal, setModal]                         = useToggle()

  const listaSubcategorias = () => {
    let lista = []
    const url = rotas.subcategoria
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S'){
          lista = ret.lista
          setListaSubcategoria(lista)
        }
        setLoading(false);
      })
      return (lista)
    }catch(err){
    }
  }

  useEffect(() => {
    const load = loading;
    if (load === true) {
      listaSubcategorias();
    }
  }, [])

  useEffect(() => {
    if(modal===false){
      listaSubcategorias()
    }
  }, [modal])

  const abreModal = (subcategoria_id) => {
    setSubcategoria_id(subcategoria_id)
    setModal()
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>CADASTRO DE SUBCATEGORIA</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Modal
                    size    = 'xl'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Cadastro de Subcategorias</ModalHeader>

                    <FormSubcategoria
                      fechaModal      = {setModal}
                      subcategoria_id = {subcategoria_id}
                    >
                    </FormSubcategoria>

                  </Modal>
                  <ToolkitProvider
                    keyField  = "subcategoria_id"
                    data      = {listaSubcategoria}
                    columns   = {colunas}
                    search
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  outline
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal('')}
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Subcategoria..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            // remote
                            keyField          = 'subcategoria_id'
                            noDataIndication  = "Nenhum registro encontrado"
                            rowStyle          = {{ cursor: "pointer" }}
                            pagination        = {paginationFactory({
                                                  sizePerPage: 10,
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                            rowEvents         = {{
                                                  onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(row.subcategoria_id)
                                                  }
                                                }}
                            {...props.baseProps}
                          />
                          <br />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default CadastroSubCategoria
